import {FC, MouseEvent, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import {getOAuthUrl} from '../../utils/apiUrl'
import {isServiceWorkerReady, waitForServiceWorkerReady} from '../../utils/serviceWorkerHelper'
import {authStyles} from '../layout/authStyles'

type OAuthProvider = 'google' | 'apple'

const SocialAuthButtons: FC = () => {
  const {t} = useTranslation()
  const [loadingProvider, setLoadingProvider] = useState<OAuthProvider | null>(null)

  const handleOAuthLogin = async (e: MouseEvent<HTMLAnchorElement>, provider: OAuthProvider): Promise<void> => {
    e.preventDefault()
    console.log(`Initiating ${provider} OAuth2 login...`)
    setLoadingProvider(provider)

    const swReady = await isServiceWorkerReady()

    if (!swReady) {
      console.log('Service worker is installing, waiting for it to be ready...')
      await waitForServiceWorkerReady(5000)
    }

    window.location.assign(getOAuthUrl(provider))
  }

  const oauthProviders: {id: OAuthProvider; icon: React.ReactNode; labelKey: string}[] = [
    {
      id: 'google',
      icon: <img src="/assets/google.png" alt="" className={authStyles.socialIcon} />,
      labelKey: 'auth:login_with_google'
    },
    {
      id: 'apple',
      icon: <img src="/assets/apple.png" alt="" className={authStyles.socialIcon} />,
      labelKey: 'auth:login_with_apple'
    }
  ]

  return (
    <div className={authStyles.socialSection}>
      {oauthProviders.map(provider => (
        <a
          key={provider.id}
          href={getOAuthUrl(provider.id)}
          className={authStyles.socialButton}
          style={{pointerEvents: loadingProvider ? 'none' : 'auto'}}
          onClick={(e) => handleOAuthLogin(e, provider.id)}
        >
          {loadingProvider === provider.id ? (
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
          ) : (
            provider.icon
          )}
          {t(provider.labelKey)}
        </a>
      ))}

      <Link
        to="/login/golfid"
        className={authStyles.socialButton}
      >
        <img src="/assets/ebirdie.png" alt="" className={authStyles.socialIcon} />
        {t('auth:login_with_ebirdie')}
      </Link>
    </div>
  )
}

export default SocialAuthButtons
